import React from "react";
function AboutSlider() {
    return (
        <>
            {/* <!-- Slider --> */}
            <br />            <br />
            <br />

            <section class="tf-slideshow about-us-page position-relative">
                <div class="banner-wrapper">
                    <img class="lazyload" src="/assets/images/slider/about-banner-01.jpg" data-src="/assets/images/slider/about-banner-01.jpg" alt="image-collection" />
                    <div class="box-content text-center">
                        <div class="container">
                            <div class="text text-white">Empowering women to achieve <br class="d-xl-block d-none" /> fitness goals with style</div>
                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}
export default AboutSlider;